// This file is auto-generated by the generateModuleTranslationKeys Vite plugin.
// Do not edit this file manually.
import { useTypedTranslation } from "@/shared/culture/useTypedTranslation";
import { useTranslationModule } from "./moduleTranslations";

export const ADMIN_TRANSLATIONS = {
  "announcements.actions.delete": "Delete",
  "announcements.actions.edit": "Edit",
  "announcements.deleteDialog.message":
    "Are you sure you want to delete this announcement?",
  "announcements.deleteDialog.title": "Delete Announcement",
  "announcements.form.message": "Message",
  "announcements.form.title": "Title",
  "announcements.form.url": "URL",
  "announcements.panel.create": "Create Announcement",
  "announcements.panel.createTitle": "Add Announcement",
  "announcements.panel.editTitle": "Edit Announcement",
  "announcements.panel.save": "Save Announcement",
  "announcements.preview": "Preview",
  "announcements.previewMessage": "Preview message",
  "announcements.table.enabled": "Enabled",
  "announcements.table.preview": "Preview",
  "announcements.table.url": "URL",
  "announcements.title": "Announcements",
  "announcements.validation.messageRequired": "Message is required",
  "announcements.validation.urlInvalid": "URL must be a valid URL",
  "cache.clear": "Clear Cache",
  "cache.emptyDescription": "The cache is currently empty.",
  "cache.emptyTitle": "No cached keys found",
  "cache.title": "Cache",
  "customApps.actions.delete": "Delete",
  "customApps.actions.edit": "Edit",
  "customApps.appearance.changeIcon": "Change Icon",
  "customApps.appearance.clear": "Clear",
  "customApps.appearance.color": "Color",
  "customApps.appearance.icon": "Icon",
  "customApps.appearance.selectIcon": "Select Icon",
  "customApps.deleteDialog.message":
    "Are you sure you want to delete {{name}}?",
  "customApps.deleteDialog.title": "Delete Custom App",
  "customApps.general.company": "Company",
  "customApps.general.host": "Host",
  "customApps.general.hostPlaceholder": "app.com",
  "customApps.general.name": "Name",
  "customApps.general.namePlaceholder": "Enter app name",
  "customApps.general.shareable": "Shareable",
  "customApps.iconSelector.cancel": "Cancel",
  "customApps.iconSelector.noIconsFound": "No icons found",
  "customApps.iconSelector.search": "Search",
  "customApps.iconSelector.select": "Select Icon",
  "customApps.iconSelector.title": "Select Icon",
  "customApps.oauth.add": "Add OAuth Callback URL",
  "customApps.oauth.backchannelLabel": "Backchannel Logout URL",
  "customApps.oauth.backchannelPlaceholder": "https://app.com/api/logout-sso",
  "customApps.oauth.callbackPlaceholder": "https://app.com/api/auth/callback",
  "customApps.oauth.callbackUrls": "Callback URLs",
  "customApps.oauth.empty": "No OAuth callback URLs",
  "customApps.oauth.frontchannelLabel": "Frontchannel Logout URL",
  "customApps.oauth.frontchannelPlaceholder": "https://app.com/logout",
  "customApps.panel.appearance": "Appearance",
  "customApps.panel.create": "Create",
  "customApps.panel.createTitle": "Create Custom App",
  "customApps.panel.editTitle": "Edit Custom App",
  "customApps.panel.general": "General",
  "customApps.panel.save": "Save",
  "customApps.platformModules.add": "Add Platform Module",
  "customApps.platformModules.empty": "No platform modules",
  "customApps.platformModules.placeholder": "Enter module name",
  "customApps.platformModules.title": "Platform Modules",
  "customApps.secret.createdTokenToast": "Created new API-token",
  "customApps.secret.onceWarning": "This can only be viewed once.",
  "customApps.secret.title": "Your Custom App Secret",
  "customApps.table.clientId": "Client ID",
  "customApps.table.company": "Company",
  "customApps.table.host": "Host",
  "customApps.table.modules": "Modules",
  "customApps.table.name": "Name",
  "customApps.title": "Custom apps",
  "customApps.validation.companyRequired": "Company is required",
  "customApps.validation.hostRequired": "Host is required",
  "customApps.validation.nameRequired": "Name is required",
  "home.announcements": "Announcements",
  "home.cache": "Cache",
  "home.customApps": "Custom Apps",
  "home.nativeApps": "Native Apps",
  "home.termsAndPrivacy": "Terms and Privacy",
  "home.title": "Admin",
  "nativeApps.allCompanies": "All Companies",
  "nativeApps.clearSelectedCompany": "Clear selected company",
  "nativeApps.disable": "Disable",
  "nativeApps.empty.noAppsFound": "No apps found",
  "nativeApps.empty.noAppsMatch": 'No apps match "{{search}}"',
  "nativeApps.empty.noNativeApps": "No native apps available",
  "nativeApps.empty.noNativeAppsDescription":
    "There are no native apps configured for this company.",
  "nativeApps.enable": "Enable",
  "nativeApps.filterByCompany": "Filter by Company",
  "nativeApps.noName": "No name",
  "nativeApps.search": "Search",
  "nativeApps.title": "Native Apps",
  "termsPrivacy.modal.acceptPrivacy": "I have read and accept the",
  "termsPrivacy.modal.acceptTerms": "I have read and accept the",
  "termsPrivacy.modal.description":
    "Before continuing, please review and accept the following documents:",
  "termsPrivacy.modal.title": "Accept Terms and Privacy",
  "termsPrivacy.noPrivacyUrl":
    "No Privacy Policy URL configured for this environment",
  "termsPrivacy.noTermsUrl":
    "No Terms of Use URL configured for this environment",
  "termsPrivacy.overviewTitle": "Terms and Privacy Overview",
  "termsPrivacy.privacyDescription":
    "Reset the Privacy Policy acceptance for all users. This will require all users to accept the privacy policy again on their next login.",
  "termsPrivacy.privacyPolicy": "Privacy Policy",
  "termsPrivacy.reset": "Reset",
  "termsPrivacy.resetDialogMessage":
    "Are you sure you want to reset the {{title}} acceptance for all users? All users will need to accept it again on their next login.",
  "termsPrivacy.resetDialogTitle": "Reset {{title}}",
  "termsPrivacy.termsDescription":
    "Reset the Terms of Use acceptance for all users. This will require all users to accept the terms again on their next login.",
  "termsPrivacy.termsOfUse": "Terms of Use",
} as const;

export const ADMIN_PLURAL_KEYS = {} as const;

export type AdminTranslationKey = keyof typeof ADMIN_TRANSLATIONS;
export type AdminPluralTranslationKey = keyof typeof ADMIN_PLURAL_KEYS;

/**
 * Typed translation hook for admin-specific keys.
 * For shared/global keys, use useCommonTranslation() instead.
 */
export function useAdminTranslation() {
  const isReady = useTranslationModule("admin", { waitForReady: true });
  return useTypedTranslation<
    AdminTranslationKey,
    typeof ADMIN_TRANSLATIONS,
    AdminPluralTranslationKey
  >(ADMIN_TRANSLATIONS, ADMIN_PLURAL_KEYS, { isReady });
}
